import * as ALL_FEATURES from './HubSpotFeature';
export const BY_PRODUCT = Object.keys(ALL_FEATURES).reduce((obj, key) => {
  const featureType = key.split('_')[0];
  if (!obj[featureType]) {
    obj[featureType] = {};
  }
  obj[featureType][key] = ALL_FEATURES[key];
  return obj;
}, {});
export const OPS_HUB_FEATURES = [ALL_FEATURES.CRM_DATA_SYNC, ALL_FEATURES.OPS_HUB_CUSTOM_FIELD_MAPPINGS, ALL_FEATURES.CRM_LINKEDIN_SYNC];